<template>
  <el-form
    @submit.native.prevent="setSave"
    ref="form"
    label-position="top"
    id="this.table"
    enctype="multipart/form-data"
  >
    <el-row type="flex" justify="space-between">
      <el-col :span="11" class="py-4">
        <el-switch
          inactive-text="Mostrar labels"
          v-model="showLabels"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch>
      </el-col>
    </el-row>

    <el-row type="flex" justify="space-between">
      <el-col :span="11">
        <el-form-item label="Título">
          <el-input v-model="template.title"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="11">
        <el-form-item label="Subtítulo">
          <el-input v-model="template.subtitle"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <app-cropper :options="options"></app-cropper>
    </el-row>

    <el-row type="flex" justify="space-between" v-if="showEditor">
      <el-col :span="24">
        <el-form-item label="Descripción">
          <app-vue-editor :value="template.description"></app-vue-editor>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row type="flex" justify="space-between">
      <el-col :span="11" v-if="showLabels">
        <el-form-item label="Label Código">
          <el-input v-model="template.codigo_label"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1" v-if="showLabels"></el-col>
      <el-col :span="11">
        <el-form-item label="Código">
          <el-input v-model="template.codigo"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1" v-if="showLabels"></el-col>
      <el-col :span="11" v-if="showLabels">
        <el-form-item label="Label Tallas">
          <el-input v-model="template.tallas_label"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1" v-if="showLabels"></el-col>
      <el-col :span="11">
        <el-form-item label="Tallas">
          <el-input v-model="template.tallas"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row type="flex" justify="space-between">
      <el-col :span="11" v-if="showLabels">
        <el-form-item label="Label Categoria">
          <el-input v-model="template.categoria_label"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1" v-if="showLabels"></el-col>
      <el-col :span="11">
        <el-form-item label="categoria">
          <el-input v-model="template.categoria"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="11" v-if="showLabels">
        <el-form-item label="Label Subcategoria">
          <el-input v-model="template.subcategoria_label"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1" v-if="showLabels"></el-col>
      <el-col :span="11">
        <el-form-item label="Subcategoria">
          <el-input v-model="template.subcategoria"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <br />
    <br />

    <template v-if="content">
      <button @click="addItem()" class="el-button el-button--primary">
        <span>Añadir documento</span>
        <i class="el-icon-circle-plus"></i>
      </button>
      <app-modal-entrada :content="content" :fichaId="fichaId" v-if="showModalAdd"></app-modal-entrada>
      <app-modal-draggable
        v-if="modalDraggable"
        :content="fecthItems"
        :name="'title'"
        :table="'fichas_archivosficha'"
      ></app-modal-draggable>

      <app-table-paginate
        :key="refresh"
        v-if="fecthItems.length > 0"
        :routeEdit="routeEdit"
        :routeDelete="routeDelete"
        :tableQuery="fecthItems"
        :tableColumns="tableColumns"
        :draggable="true"
      ></app-table-paginate>
    </template>
  </el-form>
</template>
<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import Cropper from "@/components/Dashboard/commons/cropper.vue";
import Editor from "@/components/_commons/vue-editor";
import Draggable from "@/components/Dashboard/Modals/draggable";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import Card from "@/components/Dashboard/Modals/addFileCard";

export default {
  name: "ficha",
  props: ["content"],
  components: {
    "app-cropper": Cropper,
    "app-vue-editor": Editor,
    "app-modal-draggable": Draggable,
    "app-modal-entrada": Card,
    "app-table-paginate": tablaConPaginador
  },

  async created() {
    this.routeEdit = "modal";
    this.routeDelete = "fichas_archivosficha";

    this.$root.$on("imagenCargada", file => {
      this.template.imagen = file;
    });

    this.$root.$on("delete_fichas_archivosficha", d => {
      console.log(d);
      this.eliminarRegistro(d, "fichas_archivosficha");
    });

    this.$root.$on("imagenEliminada", () => (this.template.imagen = null));

    if (this.content) {
      await this.getContent();
      await this.getTableData();
    } else {
      this.showEditor = true;
    }

    this.$root.$on("saveContent", id => {
      this.id = id;
      this.section_id = id;
      this.setSave();
    });

    this.$root.$on("openModal", id => {
      setTimeout(() => {
        this.addItem(id);
      }, 300);
    });
    this.$root.$on("closeModal", () => {
      this.showModalAdd = false;
      this.getTableData();
      this.closeModal();
    });
    this.$root.$on("draggable", e => this.showDraggable());
    this.$root.$on("vue-editor", e => {
      this.template.description = e;
    });
  },
  watch: {
    $route(to) {
      if (this.content) this.getContent();
    }
  },
  data() {
    return {
      refresh: 1,
      table: "fichas",
      template: {
        title: null,
        subtitle: null,
        imagen: "",
        description: null,
        codigo_label: null,
        codigo: null,
        tallas_label: null,
        tallas: null,
        categoria_label: null,
        categoria: null,
        subcategoria_label: null,
        subcategoria: null
      },
      id: false,
      showEditor: false,
      options: {
        img: null,
        size: 1,
        outputType: "jpg",
        canMove: true,
        canMoveBox: false,
        class: "cropper-medium",
        info: true,
        canScale: true,
        autoCrop: true,
        autoCropHeight: 450,
        autoCropWidth: 820,
        fixed: false,
        fixedBox: true,
        centerBox: true,
        fixedNumber: [820, 450]
      },
      showModalAdd: false,
      modalDraggable: false,
      routeEdit: null,
      routeDelete: false,
      tableColumns: [
        {
          prop: "title",
          label: "Título"
        },
        {
          prop: "archivo",
          label: "Documento",
          type: "file"
        }
      ],
      tableData: [],
      fichaId: false,
      showLabels: false
    };
  },
  methods: {
    async getContent() {
      const a = await ApiService.post("dashboard/table", {
        table: "fichas",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.$route.params.content_id
      });
      this.template = a.data;
      if (
        a.data.imagen != 0 &&
        a.data.imagen != "0" &&
        a.data.imagen != "null"
      ) {
        this.template.imagen = {
          url: API_UPLOADS + a.data.imagen
        };
        this.options.img = this.template.imagen.url;
        this.noImage = false;
      }
      this.showEditor = true;
    },
    async getTableData() {
      this.tableData = [];

      const a = await ApiService.post("dashboard/ficha-archivos", {
        table: "fichas_archivosficha",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        ficha_id: this.content
      });
      if (a.data !== "Algo ha fallado") {
        this.tableData = await a.data.filter(data => {
          data.archivo = API_UPLOADS + data.archivo;
          data.url = API_UPLOADS + data.url;
          data.move =
            "/dashboard/" +
            this.$route.params.db +
            "/form/edit/ficha/" +
            data.id;
          return data;
        });
      }
    },
    async setSave() {
      if (typeof this.template.imagen !== "undefined") {
        if (this.template.imagen.size) {
          let data = new FormData();
          data.append("file", this.template.imagen);
          const a = await ApiService.post("upload/contenido", data);
          this.template.imagen = a.data;
        } else if (this.template.imagen.url) {
          let e = this.template.imagen.url.replace(API_UPLOADS, "");
          let a = e.replace(API_UPLOADS + API_UPLOADS, "");
          let b = a.replace(API_UPLOADS + API_UPLOADS + API_UPLOADS, "");
          this.template.imagen = b;
        }
      } else {
        this.template.imagen = null;
      }
      this.content != 0 ? this.update() : this.insert();
    },
    async update() {
      const a = await ApiService.post("dashboard/editform", {
        table: "fichas",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.template,
        id: this.$route.params.content_id
      });
    },
    async insert() {
      const a = await ApiService.post("dashboard/editform", {
        table: "fichas",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.template
      });
      if (a.status === 200) {
        const b = await ApiService.post("dashboard/editform", {
          table: "contents",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          form: {
            template_id: 7,
            registro_id: a.data
          }
        });
        if (b.status === 200) {
          ApiService.post("dashboard/editform", {
            table: "sections_contents",
            token: localStorage.getItem("token"),
            project_id: localStorage.getItem("table"),
            form: {
              section_id: this.section_id,
              content_id: b.data
            }
          });
        }
      }
    },
    showDraggable() {
      this.modalDraggable = true;
    },
    closeModal() {
      this.modalDraggable = false;
      this.getTableData();
    },
    addItem(id = null) {
      this.fichaId = id;
      this.showModalAdd = !this.showModalAdd;
    },
    async eliminarRegistro(id, table) {
      await ApiService.post("dashboard/delete", {
        table: table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: id
      }).then(response => {
        this.getTableData();
        this.refresh++;
        if (this.deleterow == 1) {
          this.$message({
            type: "success",
            message: "Se ha eliminado correctamente"
          });
        } else {
          this.$message({
            type: "warning",
            message: this.deleterow
          });
        }
      });
    }
  },
  computed: {
    fecthItems() {
      return this.tableData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/pages/templates/ficha.vue